import React from 'react';
import { FadeIn } from './FadeIn';
import { CTAButton } from './CTAButton';
import { FileText, AlertTriangle, CheckCircle2, Package, Zap, Lock } from 'lucide-react';
export function ValueStack() {
  const items = [{
    title: "Guía Maestra: Protocolo 'Calma en Casa'",
    desc: 'El sistema CVR completo · Capítulos 1 al 7'
  }, {
    title: 'Plan de Acción de 21 Días',
    desc: 'Tu hoja de ruta diaria · Página 45 en adelante'
  }, {
    title: "Checklist 'SOS Rabietas'",
    desc: 'Para consultar en el momento de la crisis · Anexo 1'
  }, {
    title: 'Registro Semanal de Avances',
    desc: 'Para medir tu progreso semana a semana · Anexo 5'
  }];
  return <section className="py-10 md:py-20 px-5 bg-brand-navy text-white" data-id="element-186">
      <div className="max-w-3xl mx-auto" data-id="element-187">
        <FadeIn data-id="element-188">
          <h2 className="font-serif text-3xl md:text-4xl text-center mb-3 leading-snug font-bold" data-id="element-189">
            Todo lo que viene incluido dentro de tu guía por menos de lo que
            cuesta un café:
          </h2>
          <p className="text-slate-400 text-sm md:text-base text-center mb-12" data-id="element-190">
            Todo en un solo PDF. Acceso inmediato. Nada que instalar.
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-191">
          <div className="space-y-4 mb-12" data-id="element-192">
            {items.map((item, index) => <div key={index} className="flex items-start gap-4 p-4 md:p-5 rounded-xl bg-white/5 border border-white/10" data-id="element-193">
                <FileText className="w-6 h-6 text-brand-orange shrink-0 mt-1" data-id="element-194" />
                <div className="flex-grow min-w-0" data-id="element-195">
                  <div className="flex flex-wrap items-center gap-2 mb-1" data-id="element-196">
                    <h3 className="font-sans font-bold text-base md:text-lg" data-id="element-197">
                      {item.title}
                    </h3>
                    <span className="inline-flex items-center gap-1 bg-brand-orange text-white text-xs font-bold px-2.5 py-1 rounded-full whitespace-nowrap" data-id="element-198">
                      <CheckCircle2 className="w-3.5 h-3.5" data-id="element-199" />
                      INCLUIDO
                    </span>
                  </div>
                  <p className="text-slate-300 text-sm" data-id="element-200">{item.desc}</p>
                </div>
              </div>)}
          </div>

          <div className="w-full h-px bg-white/20 mb-8" data-id="element-201" />

          <div className="text-center mb-8" data-id="element-202">
            <p className="text-slate-400 text-sm line-through mb-2" data-id="element-203">
              Valor total: $85.00
            </p>
            <div className="font-sans text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-204">
              PRECIO HOY: $7.00
            </div>
            <p className="text-slate-300 text-sm font-medium" data-id="element-205">
              Pago único · Sin suscripciones · Acceso de por vida
            </p>
          </div>

          {/* Clarification box */}
          <div className="bg-[#2A3F6B] border-l-4 border-brand-orange rounded-xl p-5 mb-8" data-id="element-206">
            <div className="flex items-start gap-3" data-id="element-207">
              <Package className="w-5 h-5 text-brand-orange shrink-0 mt-0.5" data-id="element-208" />
              <div data-id="element-209">
                <p className="font-sans font-bold text-sm text-white mb-1" data-id="element-210">
                  ¿Qué recibes exactamente?
                </p>
                <p className="font-sans text-sm text-slate-300 leading-relaxed" data-id="element-211">
                  Un solo archivo PDF completo con todo el contenido, el plan de
                  21 días y todos los anexos incluidos. Sin apps. Sin claves.
                  Descargas y listo.
                </p>
              </div>
            </div>
          </div>

          {/* Urgency box */}
          <div className="bg-brand-orange rounded-xl p-4 flex items-center justify-center gap-3 mb-8 shadow-lg" data-id="element-212">
            <AlertTriangle className="w-6 h-6 text-white shrink-0" data-id="element-213" />
            <p className="text-white font-bold text-sm md:text-base" data-id="element-214">
              Precio de lanzamiento. Sube a $27 al terminar la fase beta.
            </p>
          </div>

          {/* CTA + micro-text */}
          <CTAButton mainText="DESCARGAR MI GUÍA COMPLETA POR $7" variant="white" data-id="element-215" />
          <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1 mt-4 text-xs text-slate-400" data-id="element-216">
            <span className="inline-flex items-center gap-1" data-id="element-217">
              <FileText className="w-3.5 h-3.5" data-id="element-218" />
              Un solo PDF con todo incluido
            </span>
            <span className="inline-flex items-center gap-1" data-id="element-219">
              <Zap className="w-3.5 h-3.5" data-id="element-220" />
              Acceso inmediato tras el pago
            </span>
            <span className="inline-flex items-center gap-1" data-id="element-221">
              <Lock className="w-3.5 h-3.5" data-id="element-222" />
              Procesado por Hotmart
            </span>
          </div>
        </FadeIn>
      </div>
    </section>;
}